"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = exports.StatusErrorCode = exports.ErrorGenericReasonCode = void 0;
var ErrorGenericReasonCode;
(function (ErrorGenericReasonCode) {
    ErrorGenericReasonCode["FORBIDDEN"] = "FORBIDDEN";
    ErrorGenericReasonCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorGenericReasonCode["SERVER_ERROR"] = "SERVER_ERROR";
    ErrorGenericReasonCode["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    ErrorGenericReasonCode["NOT_FOUND"] = "NOT_FOUND";
    ErrorGenericReasonCode["UNSUPPORTED_CLIENT"] = "UNSUPPORTED_CLIENT";
    ErrorGenericReasonCode["RATE_LIMIT"] = "RATE_LIMIT";
})(ErrorGenericReasonCode || (ErrorGenericReasonCode = {}));
exports.ErrorGenericReasonCode = ErrorGenericReasonCode;
var StatusErrorCode;
(function (StatusErrorCode) {
    StatusErrorCode[StatusErrorCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusErrorCode[StatusErrorCode["INVALID_ARGUMENT"] = 500] = "INVALID_ARGUMENT";
    StatusErrorCode[StatusErrorCode["INVALID_REQUEST"] = 400] = "INVALID_REQUEST";
    StatusErrorCode[StatusErrorCode["INVALID_STATE"] = 500] = "INVALID_STATE";
    StatusErrorCode[StatusErrorCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    StatusErrorCode[StatusErrorCode["RATE_LIMIT"] = 429] = "RATE_LIMIT";
    StatusErrorCode[StatusErrorCode["REQUEST_FAILED"] = 500] = "REQUEST_FAILED";
    StatusErrorCode[StatusErrorCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusErrorCode[StatusErrorCode["UNSUPPORTED_CLIENT"] = 400] = "UNSUPPORTED_CLIENT";
    StatusErrorCode[StatusErrorCode["DATA_ACCESS"] = 500] = "DATA_ACCESS";
    StatusErrorCode[StatusErrorCode["UNKNOWN"] = 500] = "UNKNOWN";
})(StatusErrorCode || (StatusErrorCode = {}));
exports.StatusErrorCode = StatusErrorCode;
var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["SOMETHING_WENT_WRONG"] = "Something went wrong. Please try again.";
    ErrorMessage["UNSUPPORTED_CLIENT"] = "Unsupported Client.";
    ErrorMessage["FORBIDDEN"] = "You do not have permission to perform this action.";
    ErrorMessage["UNAUTHORIZED"] = "Invalid Credentials.";
    ErrorMessage["NOT_FOUND"] = "Resource not found.";
    ErrorMessage["RATE_LIMIT"] = "Rate limit exceeded. Please try again later.";
})(ErrorMessage || (ErrorMessage = {}));
exports.ErrorMessage = ErrorMessage;
